// Turn string into a slug
export default function slugify(string) {
  return string
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "") //  /[^\w\-]+/g
    .replace(/--+/g, "-") //  /\-\-+/g
    .replace(/^-+/, "")
    .replace(/-+$/, "");
}



// WEBPACK FOOTER //
// ./src/utils/slugify.js